<!-- HEADER START -->
<header class="site-header header-style-1 mobile-sider-drawer-menu sticky-header">

   

    <div class="sticky-header main-bar-wraper  navbar-expand-lg">
        <div class="main-bar">

            <div class="container clearfix">

                <!-- <div class="logo-header">
                    <div class="logo-header-inner logo-header-one">
                        <a routerLink="/index">
                            <img src="assets/images/logo-dark.png" alt="">
                        </a>
                    </div>
                </div> -->
                <div class="logo-header">
                    <div class="logo-header-inner logo-header-one">
                        <a routerLink="/index">
                            <img src="assets/images/soul-space-logo.png" alt="soul space logo" title="soul space logo" height="200">

                        </a>
                    </div>
                </div>
                

                <!-- NAV Toggle Button -->
                <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button"
                    class="navbar-toggler collapsed">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar icon-bar-first"></span>
                    <span class="icon-bar icon-bar-two"></span>
                    <span class="icon-bar icon-bar-three"></span>
                </button>
                <!-- Mobile Nav Toggle Button -->
                <!-- <button id="mobile-side-drawer" class="navbar-toggler collapsed" (click)="toggleNav()">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar icon-bar-first"></span>
                    <span class="icon-bar icon-bar-two"></span>
                    <span class="icon-bar icon-bar-three"></span>
                </button> -->

                <!-- MAIN Vav -->
                <div class="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">

                    <ul class="nav navbar-nav">
                        <li class="active"><a href="javascript:void(0);" routerLink="/index" style="color: #c5a674; font-size: 19px;">Home</a>
                            <!-- <div class="fa fa-angle-right submenu-toogle"></div> -->
                             <!-- <ul class="sub-menu">
                                <li><a routerLink="/index">Industry 1</a></li>
                                <li><a routerLink="/index2">Industry 2</a></li>
                                <li><a routerLink="/index3">Garden</a></li>
                                <li><a routerLink="/index4">Construction</a></li>
                                <li><a routerLink="/index5">Transport</a></li>
                            </ul> -->
                        </li>
                        <li class="has-child"><a href="javascript:void(0);" routerLink="/about-single-page"  style="color: #5d8f61; font-size: 19px;">About Us</a>
                            <!-- <div class="fa fa-angle-right submenu-toogle"></div> -->
                             <!-- <ul class="sub-menu">
                                 
                                <li><a class="f-18" routerLink="/welcome-soul-space">Welcome to Soul Space</a></li> 
                                <li><a class="f-18" routerLink="/our-mission">Our Mission</a></li>
                                <li><a class="f-18" routerLink="/sm-our-vision">Our Vision</a></li>
                                <li><a class="f-18" routerLink="/sm-our-vision">Our Programs</a></li>
                                <li><a class="f-18" routerLink="/who-r-v">Who are we?</a></li>
                                <li><a class="f-18" routerLink="/our-journey">Our Journey</a></li>
                                <li><a class="f-18" routerLink="/why-choose-ss">Why Choose Soul Space?</a></li>
                                <li><a class="f-18" routerLink="/mental-wellbeing">Embracing Mental Wellbeing</a></li>
                            </ul>   -->
                        </li>

                        <li class="has-child"><a href="javascript:void(0);" routerLink="/our-program-single"   style="color: #b478bd; font-size: 19px;">Our Programs</a>
                            <!-- <div class="fa fa-angle-right submenu-toogle"></div>
                             <ul class="sub-menu">
                                 
                                <li><a class="f-18" routerLink="/school-program">School Mental Health Program</a></li> 
                                <li><a class="f-18" routerLink="/women-wellness">Women Wellness Program</a></li>
                                <li><a class="f-18" routerLink="/elderly-wellness">Elderly Wellness Program</a></li>

                            </ul>   -->
                        </li>

                        <!-- <li><a href="javascript:void(0);" routerLink="/our-journey">Our Journey</a>
          
                        </li> -->
                         <!-- <li class="has-child">
                            <a href="javascript:void(0);">Our Journey</a>
                            <div class="fa fa-angle-right submenu-toogle"></div> -->
                            <!-- <ul class="sub-menu">
                                
                                       
                                <li><a routerLink="/welcome-soul-space">Welcome to Soul Space</a></li>
                                  
                                <li><a routerLink="/our-mission">Our Mission</a></li>
                                <li><a routerLink="/who-r-v">Who are we?</a></li>
                                <li><a routerLink="/why-choose-ss">Why Choose Soul Space?</a></li>
                                <li><a routerLink="/mental-wellbeing">Embracing Mental Wellbeing in a Changing World</a></li>
                            </ul> -->
                        <!-- </li> -->

                        
                        
                       
                                
                                       
                                <!-- <li class="has-child"><a href="javascript:void(0);"><span class="fa fa-angle-down mainmenu-toogle"></span>School Mental Health Programs</a>
                                <div class="fa fa-angle-right submenu-toogle"></div>
                                <ul class="sub-menu">
                                  
                                    <li><a class="f-18" routerLink="/sm-our-mission">Our Mission </a></li> 
                                    <li><a class="f-18" routerLink="/sm-our-vision">Our Vision </a></li>
                                    <li><a routerLink="/who-r-v">Our Team</a></li>
                                    <li><a class="f-18" routerLink="/our-impact">Our Impact</a></li>
                                    <li><a class="f-18" routerLink="/unique-approach">Our Unique Approach</a></li>
                                    <li><a class="f-18" routerLink="/service-detail">Program Overview</a></li>
                                    <li><a routerLink="/mental-wellbeing">Success Stories</a></li>
                            </ul>  
                         </li>  -->
                         
                         <li class="has-child"><a href="javascript:void(0);" style="color: #c5a674; font-size: 19px;"><span class="fa fa-angle-down mainmenu-toogle"></span>Services</a>
                            <div class="fa fa-angle-right submenu-toogle"></div>
                            <ul class="sub-menu" [ngClass]="{'multi-column': !isLargeScreen}">
                              <li><a routerLink="/psycho-therapy">Psychotherapy Services</a></li>
                              <li><a routerLink="/anxiety">Anxiety and Depression Management</a></li>                              
                              <li><a routerLink="/anger-management">Anger Management</a></li>
                              <li><a routerLink="/ocd">Obsessive Compulsive Disorder (OCD) Treatment</a></li>
                    
                              <li><a routerLink="/ptsd">Post Traumatic Stress Disorder (PTSD) Treatment</a></li>
                              <!-- <li><a routerLink="/industrial-organizational">Industrial Psychologist</a></li> -->
                              <li><a routerLink="/career-counseling">Career Counseling for Working Professionals</a></li>
                              <li><a routerLink="/child-psychology">Child Psychology</a></li>
                              <li><a routerLink="/dyslexia">Special Education and Learning Disability Treatment</a></li>
                    
                              <!-- <li><a routerLink="/special-education">Special Education for Children with Special Needs</a></li> -->
                              <li><a routerLink="/mood-disorders">Mood Disorders Treatment</a></li>
                              <li><a routerLink="/effective-emotional">Affective and Emotional Difficulties</a></li>
                              <li><a routerLink="/behaviors-thought">Behaviors and Thought Problems</a></li>
                              <li><a routerLink="/other-services">Other Services</a></li>
                              <!-- <li><a routerLink="/corporate-wellness">Corporate Wellness Program</a></li> -->
                              <li><a routerLink="/stress-management">Stress Management</a></li>
                              <li><a routerLink="/innovative-services">Our Innovative Services</a></li>
                            </ul>
                          </li>

                          <li><a href="javascript:void(0);" routerLink="/team-our" style="color: #5d8f61; font-size: 19px;">Our Team</a>
                         
                         <!-- <li>                            
                            <a href="javascript:void(0);" routerLink="/our-services">Services</a>
                        </li> -->


                        <li><a href="javascript:void(0);" routerLink="/blog-list" style="color: #b478bd; font-size: 19px;">Blog</a>
                            <!-- <div class="fa fa-angle-right submenu-toogle"></div> 
                            <ul class="sub-menu">
                                <li><a routerLink="/blog-grid">Blog Grid</a></li>
                                <li><a routerLink="/blog-list">Blog List</a></li>
                                <li><a routerLink="/blog-single">Blog Single</a></li>
                            </ul> -->
                        </li>
                        
                        <li>
                            <a routerLink="javascript:void(0)" routerLink="/faqs" style="color: #c5a674; font-size: 19px;">FAQs</a>
                            <!--<div class="fa fa-angle-right submenu-toogle"></div>
                             <ul class="sub-menu">
                              <li></li>
                            </ul> -->
                        </li>
                        <li><a href="javascript:void(0);" routerLink="/contact" style="color: #5d8f61; font-size: 19px;">Contact Us</a></li>
                        <li>
                            <ng-container *ngIf="!applicant_token;else applicantElse">
                                <a href="javascript:void(0);" routerLink="/registration" title="Registration">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#5d8f61" d="M10 4h4v4h-4zM4 16h4v4H4zm0-6h4v4H4zm0-6h4v4H4zm10 8.42V10h-4v4h2.42zm6.88-1.13l-1.17-1.17a.41.41 0 0 0-.58 0l-.88.88L20 12.75l.88-.88a.41.41 0 0 0 0-.58M11 18.25V20h1.75l6.67-6.67l-1.75-1.75zM16 4h4v4h-4z"/></svg>
                                </a>
                            </ng-container>
                            <ng-template #applicantElse>
                                 <div class="loged-dropdown show">
                                    <a class="dropdown-toggle" href="javascript:void(0);" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  title="{{ applicant_token?.first_name + ' ' + applicant_token?.last_name + ' - ' + applicant_token?.patient_number }}">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><path fill="#6b7c52" fill-rule="evenodd" d="M256 42.667A213.333 213.333 0 0 1 469.334 256c0 117.821-95.513 213.334-213.334 213.334c-117.82 0-213.333-95.513-213.333-213.334C42.667 138.18 138.18 42.667 256 42.667m21.334 234.667h-42.667c-52.815 0-98.158 31.987-117.715 77.648c30.944 43.391 81.692 71.685 139.048 71.685s108.104-28.294 139.049-71.688c-19.557-45.658-64.9-77.645-117.715-77.645M256 106.667c-35.346 0-64 28.654-64 64s28.654 64 64 64s64-28.654 64-64s-28.653-64-64-64"/></svg>    
                                        </span>
                                    </a>
                                  
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <a class="dropdown-item" routerLink="/appointment" >Appointment</a>
                                        <a class="dropdown-item" (click)="logout()" >Logout</a>
                                    </div>
                                  </div>
                                
                            </ng-template>
                        </li>
                    </ul>

                </div>

                <!-- Header Right Section-->
                <!-- <div class="extra-nav header-1-nav">
                    <div class="extra-cell one">
                        <div class="header-search">
                            <a id="#search" class="header-search-icon"><i class="fa fa-search"></i></a>
                        </div>
                    </div>
                    <div class="extra-cell two">
                        <div class="ap-btn-outer">
                            <a class="ap-btn contact-slide-show">Request A Quote <i
                                    class="fa fa-angle-double-right slide-right"></i></a>
                        </div>
                    </div>
                </div> -->

                <!-- Contact Nav -->
                <div class="contact-slide-hide bg-cover">
                    <div class="contact-nav">
                        <a href="javascript:void(0)" class="contact_close">&times;</a>
                        <div class="contact-nav-form p-a30">
                            <div class="contact-info   m-b30">

                                <div class="wt-icon-box-wraper center p-b30">
                                    <div class="icon-xs m-b20 scale-in-center"><i class="fa fa-phone"></i></div>
                                    <div class="icon-content">
                                        <h4 class="m-t0  wt-title">Phone number</h4>
                                        <p>+(02) 0111-7457-354</p>
                                    </div>
                                </div>

                                <div class="wt-icon-box-wraper center p-b30">
                                    <div class="icon-xs m-b20 scale-in-center"><i class="fa fa-envelope"></i></div>
                                    <div class="icon-content">
                                        <h4 class="m-t0 wt-title">Email address</h4>
                                        <p>demomax@gmail.com</p>
                                    </div>
                                </div>

                                <div class="wt-icon-box-wraper center p-b30">
                                    <div class="icon-xs m-b20 scale-in-center"><i class="fa fa-map-marker"></i></div>
                                    <div class="icon-content">
                                        <h4 class="m-t0  wt-title">Address info</h4>
                                        <p>92 Princess Road, parkvenue</p>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <span>&copy; 2021 Mysoulspace</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SITE Search -->
                <div id="search">
                    <span class="close"></span>
                    <form role="search" id="searchform" action="/search" method="get" class="radius-xl">
                        <div class="input-group">
                            <input class="form-control" value="" name="q" type="search" placeholder="Type to search" />
                            <span class="input-group-append"><button type="button" class="search-btn"><i
                                        class="fa fa-paper-plane"></i></button></span>
                        </div>
                    </form>


                </div>



            </div>


        </div>
    </div>


</header>
<!-- HEADER END -->